import React from 'react'

function LoadingScreen() {
  return (
    <div className='w-100 h-100 d-flex justify-content-center align-items-center flex-column'>
      <div id='loading' className='dark'></div>
      <p className='mt-4'>Loading...</p>
    </div>
  )
}

export default LoadingScreen
